<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"
        >{{ $t('ITEM.EDIT') }} {{ $t('CONTACT_PERSONS.ITEM') }}</span
      >
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container grid-list-xl>
          <contact-person-form
            v-model="contactPerson"
            :company="company"
            :errors="errors.getAll()"
            :select-person="false"
            @update-prop="clearErrorByName($event)"
          ></contact-person-form>
        </v-container>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>

            <v-btn
              color="success"
              :disabled="!valid"
              :loading="isLoading"
              @click="validate"
              >{{ $t('BUTTON.UPDATE') }}</v-btn
            >
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'ViewContactPerson',

  components: {
    ContactPersonForm: () => import('./forms/ContactPersonForm')
  },

  mixins: [errors, i18nRefreshData],

  props: {
    id: {
      type: Number,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    valid: true,
    selectPerson: true,
    contactPerson: {
      user: {},
      person: {}
    }
  }),

  computed: {
    isLoading() {
      return this.$store.getters['loading'];
    },

    actionTitle() {
      return this.selectPerson ? this.$t('ITEM.ADD') : this.$t('ITEM.EDIT');
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('contact_person', [
      'updateContactPerson',
      'getContactsPerson'
    ]),

    refreshData() {
      this.getContactsPerson({ contactPersonId: this.id }).then(({ data }) => {
        this.contactPerson = data;
      });
    },

    validate() {
      if (this.$refs.form.validate()) {
        const contactPerson = {
          ...this.contactPerson,
          company_id: this.company.id
        };

        this.updateContactPerson({
          contactPersonId: this.id,
          contactPerson
        })
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('updated', data.data);
          })
          .catch(({ response }) => {
            this.handleErrorsByResponse(response);
          });
      }
    }
  }
};
</script>
